
export enum GameFases {
  StartGame=0,
  Interaction,
  InteractionExplanation,
  SuccessFeedBack,
  FailFeedBack,
  Loading,
  LockedOrUnaveable
}


interface GameCardStyle {
  icon: string;
  icon_url: string;
  bg_color: string;
  font_color: string;
  action_button_bg_color: string;
  action_button_font_color: string;
}

interface GameUserScore {
  type: 'coupons' | 'points';
  value: number;
}

export interface Game {
  idPromoFase: number;
  idGame: number;
  idStage: number;
  rebilling_code?: number,
  paid_only?: number,
  utm_source?: string;
  utm_game?: string;

  // "rebilling_code": 109,
  // "paid_only": 1,
  // "1" = "bolao" (que aparece embaixo) |
  // "2" = "bolao" (que aparece emcima junto com outros games) |
  // ...
  type: number;

  name: string;
  description: string;

  card_style: GameCardStyle;

  status: GameStatus; // 0-liberado, 1-jogado, 2-bloqueado
  user_score: GameUserScore[];

  results?: GameResults[];

  matches?: Match[];
  end_date?:string;

  // coupons: number;
  // action?: {
  //   name: string;
  //   fn: () => void;
  // };
  // rememberMe: boolean;
  // isBlocked: boolean;
}

export interface Match {
  idMatch: number;
  name: string;
  place: string;
  matchStart: string;
  status: number;
  teams: Team[];
  score: GameUserScore[];
}

export interface Team {
  id: number;
  name: string;
  flag: string;
  guess?: number | null;
  result?: number | null;
}

/* ATILA 11/07/22 - Skype PROMO HUB + ATILA
 - 0 = aberto para jogar, existem perguntas pendentes ("jogar agora")
 - 1 = aguarda liberação da próxima rodada ("você já jogou hoje / volte amanhã")
 - 2 = bloqueado, pois o game não foi lançado ainda para a fase atual ("avise-me quando lançar")
 - 3 = bloqueado, pois o game não foi lançado ainda para a fase atual ("avise-me quando lançar")
 - 4 = finalizado. já jogou o jogo inteiro. ("este game expirou nesta fase")

 EDIT 13/09/23 - Call Alinhamento Panama
 - 5 = sem vida ou sem credito  
 */


export enum GameStatus {
  Unlocked = 0,
  Played,
  Locked,
  WarnMe,
  Finished,
  NoLivesOrCredits
}

/**

O jogo sempre pode entrar, muda o botão se pode jogar
Caso não assinante e game só para assinantes, aparace botão de assinar
Caso não assinante e game para todos e não pode jogar, aparece botão de cobrar(microbilling)
Caso assinante e não pode jogar, aparece botão de cobrar(microbilling)

pode jogar?
  jogo1 liberado para todos
  jogo2 só para assinantes

nao assinante:
  jogo1 pode comprar
  jogo2 pode entrar na tela (botao para assinar)

assinante:
  jogo1 pode comprar
  jogo2 pode comprar

 */


export enum GameStatusClaro {
  CanBuy = 0,
  CanSubscribe,
  None
}



// Bolão	1
// Cinco Letras	3
// Código Secreto	4
// Missão Premiada	5
// Quiz Libertadores	6


export enum GameDetailType {
  PredictScore = 1,
  Keyword = 3,
  Live = 4,
  Mission = 5,
  Quiz = 6,
  Roulette = 10,
  ScratchCard = 7,
  GoalKick = 666,
  SevenErrors = 12,
  Form = 14,
  RouletteSmart = 15,
}

export interface GameQuestionDetail {
  right: number;
  wrong: number;
  qtd_day: number;
  answered: number;
  total: number;
  pending_day: number;
}

export enum GameScoreType {
  Cupouns = 'cupouns',
  Points = 'points',
  LucknumberWon = 'lucknumber_won',
  LucknumberTotal = 'lucknumber_total'
}

export enum Fomate {
  SinglePage = 'single_page',
  Default = 'default'
}


export interface GameScore {
  type: GameScoreType;
  value: number;
}

export interface GameDetail {
  idStage: number;
  idGame: number;
  stage_name: string;
  type: number;
  formate?: Fomate;
  rebilling_code?: number;
  is_paid_only?: boolean;
  utm_source?:string;
  description: string;
  status: GameStatus;
  dt_end: string;
  dt_start: string;
  questions: GameQuestionDetail;
  score: GameScore[];
}

/*
{
  "id_game": "qHA967DOTKLrs7z+JHOg6OX7mJRxEUYWI27oynr/5v0=",
  "type": 1, // tipo do jogo, a ser definido, ex: 0-bolão, 1-quiz
  "description": "Aqui no quiz....",
  "status": 0, // 0-liberado, 1-jogado, 2-bloqueado
  "questions": {
    "right": 5,
    "wrong": 1,
    "total": 10 // peding = total - (right + wrong)
  },
  "score": [
    {
      "type": "cupouns",
      "value": 238
    },
    {
      "type": "points",
      "value": 50
    }
  ]
}
*/

export interface GameQuestionAnswer {
  idAnswer: number;
  text: string;
  value: number;
}

export interface GameQuestion {
  idGame: number;
  idFase: number;
  idQuestion: number;
  text: string;
  has_next: boolean;
  answers: GameQuestionAnswer[];
}

export interface GameAnswerFeedback {
  timestamp: string;
  status: number;
  message: string;
  lucknumber_won?:number;
  idCorrectAnswer: number;
}

/*
{
  "id_game": "",
  "id_promo_fase": "",
  "id_question": "",
  "text": "Quem descobriu o Brasil?",
  "answers": [
    {
      "id_answer": "",
      "text": "Blá",
      "value": 0
    },
    {
      "id_answer": "",
      "text": "Teste",
      "value": 1
    }
  ],
  "has_next": true // flag indicando se tem mais pergunta disponível
}
*/

export interface GameResults {
  question: string;
  answer: string;
  is_correct: boolean;
  dt_result:string;
  result: string;
  boleto:string;
}
